import {
	GET_FACILITATING_COURSES_REQUEST,
	GET_FACILITATING_COURSES_SUCCESS,
	GET_FACILITATING_COURSES_ERROR,
	GET_FACILITATING_COURSE_REQUEST,
	GET_FACILITATING_COURSE_SUCCESS,
	GET_FACILITATING_COURSE_ERROR,
	CREATE_FACILITATING_COURSE_REQUEST,
	CREATE_FACILITATING_COURSE_SUCCESS,
	CREATE_FACILITATING_COURSE_ERROR,
	EDIT_FACILITATING_COURSE_REQUEST,
	EDIT_FACILITATING_COURSE_SUCCESS,
	EDIT_FACILITATING_COURSE_ERROR,
	DELETE_FACILITATING_COURSE_REQUEST,
	DELETE_FACILITATING_COURSE_SUCCESS,
	DELETE_FACILITATING_COURSE_ERROR
} from "../../actions"

import {
	facilitatingCourseService
} from "../../services";

import { addNewFilter, isEmpty } from "@/utilities"

const state = {
	facilitatingCourses: [],
	facilitatingCourse: {},
	loading: false,
	loadedOnce: false
}

const getters = {
	fcLoading: state => loading,
	fcLoadedOnce: state => loadedOnce,
	facilitatingCourses: state => state.facilitatingCourses?.sort((a, b) => a.sort - b.sort) ?? [],
	facilitatingCourseSelectOptions: state => state.facilitatingCourses.sort((a, b) => a.sort - b.sort).map(fc => ({ value: fc.uuid, label: fc.label })),
	facilitatingCourseMultiSelectOptions: state => state.facilitatingCourses.sort((a, b) => a.sort - b.sort).map(fc => ({ value: fc.uuid, text: fc.label }))
}

const actions = {
	async getFacilitatingCourses({ commit }) {
		commit("GET_FACILITATING_COURSES_REQUEST")
		const response = await facilitatingCourseService.getFacilitatingCourses();
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_FACILITATING_COURSES_SUCCESS", data)
				break
			default:
				commit("GET_FACILITATING_COURSES_ERROR", data)
		}
		return response
	},
	async getFacilitatingCourse({ commit }, params) {
		commit("GET_FACILITATING_COURSE_REQUEST")
		const response = await facilitatingCourseService.getFacilitatingCourse(params)
		const { status, data } = response
		switch (status) {
			case 200:
				commit("GET_FACILITATING_COURSE_SUCCESS", data)
				break
			default:
				commit("GET_FACILITATING_COURSE_ERROR", data)
				break
		}
		return response
	},
	async createFacilitatingCourse({ commit }, params) {
		commit("CREATE_FACILITATING_COURSE_REQUEST")
		const response = await facilitatingCourseService.createFacilitatingCourse(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data.success) {
					commit("CREATE_FACILITATING_COURSE_SUCCESS", data);
				}
				
				break
			default:
				commit("CREATE_FACILITATING_COURSE_ERROR", data)
		}
		return response
	},
	async editFacilitatingCourse({ commit, dispatch }, params) {
		commit("EDIT_FACILITATING_COURSE_REQUEST")
		const response = await facilitatingCourseService.editFacilitatingCourse(params)
		const { status, data } = response
		switch (status) {
			case 200:
				if (data?.success) {
					commit("EDIT_FACILITATING_COURSE_SUCCESS", data);
				}
				
				break
			default:
				commit("EDIT_FACILITATING_COURSE_ERROR", data)
		}
		return response
	},
	async deleteFacilitatingCourse({ commit }, params) {
		commit("DELETE_FACILITATING_COURSE_REQUEST")
		const response = await facilitatingCourseService.deleteFacilitatingCourse(params)
		const { status, data } = response
		switch (status) {
			case 200:
				commit("DELETE_FACILITATING_COURSE_SUCCESS", data)
				break
			default:
				commit("DELETE_FACILITATING_COURSE_DELETE", data)
		}
		return response
	},
	async reorderFacilitatingCourses({ commit }, params) {
		return await facilitatingCourseService.reorderFacilitatingCourses(params)
	},
	async updateSortOrder({ commit }, params) {
		commit("UPDATE_SORT_ORDER", params)
	}
}

const mutations = {
	[GET_FACILITATING_COURSES_REQUEST]: state => {
		state.loading = true
	},
	[GET_FACILITATING_COURSES_SUCCESS]: (state, data) => {
		const facilitatingCourses = data.facilitating_courses
		state.facilitatingCourses = facilitatingCourses
		state.loading = false
	},
	[GET_FACILITATING_COURSES_ERROR]: state => {
		state.loading = false
		state.error = true
	},
	[GET_FACILITATING_COURSE_REQUEST]: state => {
		state.loading = true
	},
	[GET_FACILITATING_COURSE_SUCCESS]: (state, data) => {
		const { facilitating_course } = data;
		state.facilitatingCourses = addNewFilter(state.facilitatingCourses, [facilitating_course]);
		state.loading = false
	},
	[GET_FACILITATING_COURSE_ERROR]: (state, data) => {
		state.loading = false
	},

	[CREATE_FACILITATING_COURSE_REQUEST]: state => {
		state.loading = true
	},
	[CREATE_FACILITATING_COURSE_SUCCESS]: (state, data) => {
		const { facilitating_course } = data;
		state.facilitatingCourses = addNewFilter(state.facilitatingCourses, [facilitating_course]);
		state.loading = false
	},
	[CREATE_FACILITATING_COURSE_ERROR]: state => {
		state.loading = false
	},

	[EDIT_FACILITATING_COURSE_REQUEST]: state => {
		state.loading = true
	},
	[EDIT_FACILITATING_COURSE_SUCCESS]: (state, data) => {
		const { facilitating_course } = data;
		state.facilitatingCourses = addNewFilter(state.facilitatingCourses, [facilitating_course]);
		state.loading = false
	},
	[EDIT_FACILITATING_COURSE_ERROR]: state => {
		state.loading = false
	},

	[DELETE_FACILITATING_COURSE_REQUEST]: state => {
		state.loading = true
	},
	[DELETE_FACILITATING_COURSE_SUCCESS]: (state, data, { uuid }) => {
		state.loading = false
	},
	[DELETE_FACILITATING_COURSE_ERROR]: (state, data) => {
		state.loading = false
	},
	UPDATE_SORT_ORDER: (state, data) => {
		state.facilitatingCourses = state.facilitatingCourses.map(fc => {
			return fc.uuid === data.uuid ? { ...fc, sort: data.sort } : fc;
		})
	}
}

export const facilitatingCourse = {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}